import { API_URL } from './constants'

export type AccountEmailStatus = {
  state: 'VISITOR' | 'EMAIL_UNBOUND' | 'EMAIL_UNVERIFIED' | 'EMAIL_VERIFIED'
  email: string | null
  sentAt: string | null
}

export class AccountEmailError extends Error {
  constructor(public code: string, public seconds?: number) {
    super(code)
  }
}

export async function accountEmailRequest<T>(
  path: string,
  body?: Record<string, unknown>,
): Promise<T> {
  const response = await fetch(`${API_URL}/api/auth/${path}`, {
    method: body ? 'POST' : 'GET',
    credentials: 'include',
    ...(body ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {}),
  })
  const result = await response.json()
  if (!response.ok)
    throw new AccountEmailError(result.code ?? 'UNKNOWN', result.seconds)
  return result as T
}

export function privateEmailLabel(email: string) {
  const [name, domain] = email.split('@')
  return `${name.slice(0, 2)}***@${domain}`
}
